import React from 'react';
import TextField from '@material-ui/core/TextField';
import MenuItem from '@material-ui/core/MenuItem';
import { Typography } from '@material-ui/core';
import {observer} from "mobx-react-lite";
import {useWebsocketStore} from "../../../../stores/websocketStore/websocketProvider";

const AccountNumberDropDown = observer(({top, dispatchTop}) => {
  const {accountBalanceStore} = useWebsocketStore();
  const balances = accountBalanceStore.balances;
  let accounts = [];
  if (top.dataSource === 'LIVE') {
    if (balances !== undefined) {
      for (let accountId in balances) {
        if (accountId === 'BACKTEST') {
          continue;
        }
        let account = {
          accountId: accountId,
          nickname: balances[accountId].nickname,
          accountType: balances[accountId].account_type,
          brokerage: balances[accountId].brokerage,
        };
        accounts.push(account);
      }
    }
  } else {
    accounts.push({
      accountId: 'BACKTEST',
      nickname: 'SIM',
      brokerage: 'BACKTEST',
    });
  }

  return (
      <BuildDropDown
          accounts={accounts}
          top={top}
          dispatchTop={dispatchTop}
      />
  );
});

export default AccountNumberDropDown
/*export default class AccountNumberDropDown extends React.Component {
  constructor(props) {
    super(props);
    this.observable = BalancesObservable;
    this.state = { balances: {} };
  }

  componentDidMount() {
    this.subscription = this.observable.subscribe((value) =>
      this.setState({ balances: value })
    );
  }

  componentWillUnmount() {
    this.subscription.unsubscribe();
  }

  render() {
    let accounts = [];
    if (
      this.props.top.dataSource === 'LIVE' &&
      this.props.top.brokerage !== 'BACKTEST'
    ) {
      if (this.state.balances !== undefined) {
        for (let accountId in this.state.balances) {
          if (accountId == 'BACKTEST') {
            continue;
          }
          let account = {
            accountId: accountId,
            nickname: this.state.balances[accountId].nickname,
          };
          accounts.push(account);
        }
      }
    } else {
      accounts.push({ accountId: 'BACKTEST', nickname: 'SIM' });
    }
    return (
      <BuildDropDown
        accounts={accounts}
        top={this.props.top}
        dispatchTop={this.props.dispatchTop}
      />
    );
  }
}*/

function BuildDropDown({ accounts, top, dispatchTop }) {
  return (
    <>
      <TextField
        select
        value={top.accountNumber !== 'none' ? top.accountNumber : ''}
        variant="outlined"
        size="small"
        style={{ backgroundColor: 'white', width: '100%' }}
        onChange={(ev) => {
          const accountId = ev.target.value;
          const selected = accounts.find(
            (account) => account.accountId === accountId
          );
          const nextState = { accountNumber: accountId };
          if (selected?.brokerage) nextState.brokerage = selected.brokerage;
          dispatchTop(nextState);
        }}
        label={<Typography style={{ fontSize: 10 }}>account #</Typography>}
      >
        {accounts.map((account) => (
          <MenuItem key={account.accountId} value={account.accountId}>
            <Typography style={{ fontSize: 9 }}>
              {buildAccountLabel(account)}
            </Typography>
          </MenuItem>
        ))}
      </TextField>
    </>
  );
}

function buildAccountLabel(account) {
  const parts = [];
  if (account.nickname) parts.push(account.nickname);
  if (account.accountId) parts.push(account.accountId);
  if (account.accountType) parts.push(account.accountType);
  return parts.length > 0 ? parts.join(' - ') : 'Account';
}
